<template>
  <card class="card-user">
    <div slot="image">
      <img src="/static/img/fondo_perfil.jpg" alt="...">
    </div>
    <div>
      <div class="author">
        <img v-if="user.avatar" class="avatar border-gray" :src="user.avatar" alt="...">
        <img v-else class="avatar border-gray" src="/static/img/avatar-dafult.svg">
        <h5 class="title"> {{ user.first_name }} {{ user.last_name }}
          <br>
          <a href="#">
            <small>{{ user.username }}</small>
          </a>
        </h5>
      </div>
      <hr>
      <p class="description text-center">
        <span v-if="user.description">
          {{ user.description }}
        </span>
        <span v-else>
          En esta sección podras visualizar la información de la descripción del usuario.
        </span>
      </p>
    </div>
  </card>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        user: 'auth/user'
      })
    }
  }
</script>
<style>
.card .description {
    width: 90%;
    margin: 10px auto;
}
</style>
